module.exports = __webpack_public_path__ + "static/media/team-member-03.398bb406.jpg";